import { render, staticRenderFns } from "./PermissionsPermissionTypesList.vue?vue&type=template&id=257f0f8f&"
import script from "./PermissionsPermissionTypesList.vue?vue&type=script&lang=js&"
export * from "./PermissionsPermissionTypesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports